export default "<p>\r\n  cpe-factura works!\r\n</p>\r\n"